import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getHeaders } from 'auth/auth';
import { api } from 'constants/constant';

export const dashboardAPI = createApi({
  reducerPath: 'dashboard',
  baseQuery: fetchBaseQuery({ baseUrl: api, credentials: 'include' }),
  endpoints: (builder) => ({
    getApplicationDashboardInfo: builder.query({
      query: (applicationId) => {
        return {
          url: `b2c/loan/dashboard/loan_info/${applicationId}`,
          method: 'GET',
          headers: getHeaders(),
        };
      },
    }),
  }),
});

export const { useGetApplicationDashboardInfoQuery } = dashboardAPI;
